<template>
  <div id="app">
    <Header></Header>
    <div>
      <router-view />
    </div>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  font-family: "微软雅黑";
  overflow-x: hidden;
}
.ql-editor {
  padding: 0;
}
.ql-editor p {
  letter-spacing: 1px;
  line-height: 27px;
}
@media screen and (max-width: 767px) {
  #smartTown {
    padding: 0;
    width: 100%;
    position: relative;
  }
  .ql-editor {
    padding: 0 !important;
  }
  .ql-editor p img {
    width: 90% !important;
  }
  .ql-editor p {
    letter-spacing: 2px;
    line-height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue